import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageTitle, Card, Notice } from "../components/kit";
import { Loading, HistoryList } from "../components/common";
import { api } from "../lib/api";

export default function AuditLog() {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)); }, []);
  return (
    <div className="mx-auto max-w-3xl">
      <PageTitle title={t("audit.title")} sub={t("audit.sub")} />
      <div className="mb-4"><Notice>{t("audit.note")}</Notice></div>
      <Card>{items ? <HistoryList items={items.map((i) => ({ ...i, action: i.action, reason: i.reason }))} testid="audit-list" /> : <Loading />}</Card>
    </div>
  );
}
